import { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
	Calendar,
	Contributors,
	Homes,
	Lifebooks,
	Loader,
	ResourceParents,
	Snapshots,
	Support,
	Vault,
} from 'components';
import { setFetchedHouseList } from 'services';

export default function CaseManagerRouter() {
	const [homesLoaded, setHomesLoaded] = useState(false);
	const child = useSelector((state) => state.lifebooks.child);
	const privateProfilePath = child?.id ? `/connect/child/${child.id}` : null;

	useEffect(() => {
		let mounted = true;

		setFetchedHouseList()
			.catch(() => null)
			.finally(() => {
				if (mounted) setHomesLoaded(true);
			});

		return () => {
			mounted = false;
		};
	}, []);

	if (!homesLoaded) return <Loader />;

	return (
		<Switch>
			<Route path='/connect/vault/:feedType?/:childId?/:postId?'>
				{child?.privatizePosts && privateProfilePath ? (
					<Redirect to={privateProfilePath} />
				) : (
					<Vault basePath='/connect/vault' trustedCaseManagerRoute />
				)}
			</Route>
			<Route path='/connect/archive/:feedType?/:childId?'>
				{child?.privatizePosts && privateProfilePath ? (
					<Redirect to={privateProfilePath} />
				) : (
					<Snapshots basePath='/connect/archive' trustedCaseManagerRoute />
				)}
			</Route>
			<Route path='/connect/calendarActivity/:childId?'>
				<Calendar
					basePath='/connect/calendar'
					activityBasePath='/connect/calendarActivity'
					trustedCaseManagerRoute
				/>
			</Route>
			<Route path='/connect/calendar/:childId?'>
				<Calendar
					basePath='/connect/calendar'
					activityBasePath='/connect/calendarActivity'
					trustedCaseManagerRoute
				/>
			</Route>
			<Route path='/connect/homes/:pageType?/:houseId?'>
				<Homes
					basePath='/connect/homes'
					lifebookBasePath='/connect'
					resourceParentsBasePath='/connect/resource-parents'
					trustedCaseManagerRoute
				/>
			</Route>
			<Route path='/connect/resource-parents/:pageType?/:rpId?'>
				<ResourceParents
					basePath='/connect/resource-parents'
					homesBasePath='/connect/homes'
					trustedCaseManagerRoute
				/>
			</Route>
			<Route path='/connect/contributors/:pageType?/:contributorId?'>
				<Contributors
					basePath='/connect/contributors'
					trustedCaseManagerRoute
				/>
			</Route>
			<Route path='/connect/support/:supportId?'>
				<Support
					basePath='/connect/support'
					contactOnly
				/>
			</Route>
			<Route path='/connect/:feedType?/:childId?/:postId?'>
				<Lifebooks baseRoute='connect' trustedCaseManagerRoute />
			</Route>
			<Redirect to='/connect/' />
		</Switch>
	);
}
